import {Typography} from '@material-ui/core';

const Label = ({label, children, style, grey}) => {
    return (
        <Typography style={{ color: grey? '#b1b1b1': 'black', fontWeight: grey? 'unset': 'bold', ...style}}>{label}{children}</Typography>
    );
};

export default Label;
